<template>
  <div class="flexbox">
    <div class="num">{{num + 1}}</div>
    <div class="id">Device lD: cpr{{arr.device_id}}</div>
    <!-- <img src="@/assets/refresh.png" class="refresh" alt=""> -->
    <div class="status" v-show="arr.rate == 0 || !arr.rate">
      <img src="@/assets/no.png" alt="">
    </div>
    <div class="data">
      <div class="left">
        <div class="line_box" :class="arr.fw == 'true' ? 'reback':''" v-for="(item,i) in 9" :key="i">
          <span class="line" :class="arr.qualified === '合格' ? 'green' : 'yellow'"></span>
        </div>
      </div>
      <div class="right">
        <div class="press">
          总按压：{{arr.total}}
        </div>
        <!-- <div class="rate" :class="{ red: arr.rate > 120, yellow: arr.rate < 90 }">
          {{arr.rate}}
        </div> -->
        <div class="rate1" :style="styObj">
          <div class="point_box">
            <div class="point"></div>
            <div class="shan1"></div>
            <div class="line-tick line-tick1">
              <div class="tick"></div>
              <div class="num">0</div>
            </div>
            <div class="line-tick line-tick2">
              <div class="tick"></div>
              <div class="num">50</div>
            </div>
            <div class="line-tick line-tick3">
              <div class="tick"></div>
              <div class="num">100</div>
            </div>
            <div class="line-tick line-tick4">
              <div class="tick"></div>
              <div class="num">150</div>
            </div>
            <div class="line-tick line-tick5">
              <div class="tick"></div>
              <div class="num">200</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewBox',
  data() {
    return {
      // rate:50,
      timer:""
    }
  },
  props: ['num','arr'],
  mounted() {
    // this.timer = setInterval(() => {
    //   if(this.rate < 200){
    //     this.rate = this.rate + 20
    //   }else{
    //     this.rate = 0
    //   }
    // }, 1000);
  },
  computed: {
    styObj(){
      let rotateDeg = "";
      let conicDeg = "";
      let color = ""
      if(this.arr.rate<0){
        // eslint-disable-next-line
        rotateDeg = "rotate(0deg)";
        // eslint-disable-next-line
        conicDeg = "0%";
      }else if(this.arr.rate>200){
        // eslint-disable-next-line
        rotateDeg = "rotate(180deg)";
        // eslint-disable-next-line
        conicDeg = "0%";
        color = '##f10f0f'
      }else{
        // eslint-disable-next-line
        rotateDeg = `rotate(${(this.arr.rate/200)*180}deg)`;
        // eslint-disable-next-line
        conicDeg = `${(this.arr.rate / 200) * (180 / 360) * 100}%`;
        // eslint-disable-next-line
        if(this.arr.rate < 90){
          color = '#f5e226'
        }else if(this.arr.rate > 120){
          color = '#f10f0f'
        }else{
          color = '#62db00'
        }
      }
      
      return{
        "--background-wrapper": `conic-gradient(${color} 0%, ${color} ${conicDeg}, transparent ${conicDeg})`,
        "--background-inner": `conic-gradient(#073358 0%, ${color} ${conicDeg}, transparent ${conicDeg})`,
        "--pointer-rotate": rotateDeg,      
      }
      
    }
  },
}
</script>

<style scoped lang="less">
.flexbox{
  width: 5.6rem;
  max-width: 325px;
  height: calc(0.7*6rem);
  max-height: calc(0.7*325px);
  background: rgb(26, 26, 26);
  margin-bottom: .8rem;
  position: relative;
  border-radius: .15rem;
  overflow: hidden;
  .num{
    color: #9ea3a3;
    font-size: .5rem;
    position: absolute;
    left: .125rem;
    top: .0625rem;
    z-index: 10;
    @media screen and (min-width: 1400px) {
      font-size: 30px;
    }
  }
  .id{
    color: #9ea3a3;
    position: absolute;
    bottom: .16rem;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    font-size: .25rem;
    @media screen and (min-width: 1400px) {
      font-size: 15.1px;
    }
  }
  .refresh{
    position:absolute;
    width: .7rem;
    right: .1rem;
    bottom: .16rem;
    max-width: 30px;
  }
  .status{
    width: 100%;
    height: 100%;
    position: relative;
    background: #575757;
    z-index: 9;
    img{
      width: 40%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
  }
  .data{
    width: 4.6rem;
    max-width: 255px;
    height: calc(0.7*4rem);
    max-height: calc(0.6*255px);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    display: flex;
    .left{
      width: 40%;
      height: 100%;
      display: flex;
      flex-direction: column;
      .reback:nth-child(1){
        .line{
          background: #f10f0f!important;
        }
      }
      .line_box{
        width: 100%;
        height: 100%;
        flex: 1;
        display: flex;
        .line{
          display: block;
          width: 90%;
          height: .065rem;
          margin: auto;
          border-radius: 2px;
          background: #f5e226;
        }
        .line.yellow{
          background: #f5e226;
        }
        .line.green{
          background: #62db00;
        }
      }
    }
    .right{
      width: 60%;
      height: 100%;
      text-align: center;
      position: relative;
      .press{
        color: #9ea3a3;
        font-weight: 500;
        position: absolute;
        white-space: nowrap;
        font-size: .34rem;
        // top: .225rem;
        left: 50%;
        transform: translateX(-50%);
        @media screen and (min-width: 1400px) {
          font-size: 18px;
        }
      }
      .rate{
        color: #fff;
        font-size: 1.4rem;
        position: absolute;
        bottom: .2rem;
        left: 50%;
        transform: translateX(-50%) ;
        @media screen and (min-width: 1400px) {
          font-size: 72px;
        }
      }
      .rate.yellow{
        color: #f5e226;
      }
      .rate.red{
        color: #f10f0f;
      }
      .rate1::after{
        content:"";
        position: absolute;
        width: 2.4rem;
        height: 2.4rem;
        top: 0;
        left: 0;
        border-radius: 100%;
        z-index: -1;
        background-image: var(--background-inner);
        transform: rotate(-90deg);
        transition: background-image 2s;
        @media screen and (min-width: 1400px) {
          width: 120px;
          height: 120px;
        }
      }
      .rate1{
        width: 100%;
        left: 55%;
        transform: translateX(-50%);
        height: 1.2rem;
        width: 2.4rem;
        border-radius: 2.4rem 2.4rem 0 0;
        position: absolute;
        bottom: .2rem;
        border: 2px solid #9ea3a3;
        border-bottom: none;
        @media screen and (min-width: 1400px) {
          height: 60px;
          width: 120px;
          border-radius: 120px 120px 0 0;
        }
        .point_box{
        width: 100%;
        height: 100%;
        position: relative;
          .point{
            width: 35%;
            height: 1px;
            background: #fff;
            position: absolute;
            bottom: 0px;
            right: 50%;
            // clip-path: polygon(0 1px, 40px 0, 40px 40px);
						transform-origin: right center;
            transition: transform 1s;
            transform: var(--pointer-rotate);
          }
          .line-tick{
            position: absolute;
            left: 0;
            bottom:0;
            width: 1.2rem;
            height: 2px;
						transform-origin: right center;
            @media screen and (min-width: 1400px) {
              width: 60px;
            }
            .tick{
              width: 10%;
              height: 100%;
              background: #fff;
            }
            .num{
              color: #9ea3a3;
              font-size: 0.2rem;
            }
          }
          .line-tick1 .num{position: absolute;left: -0.2rem;top:-5px; }
          .line-tick2{
            transform: rotate(45deg);
          }
          .line-tick2 .num{
            position: absolute;
            left: -0.3rem;
            top:-5px;
            transform: rotate(-90deg); 
          }
          .line-tick3{
            transform: rotate(90deg);
          }
          .line-tick3 .num{
            position: absolute;
            left: -0.3rem;
            top:-5px;
            transform: rotate(-90deg); 
          }
          .line-tick4{
            transform: rotate(135deg);
          }
          .line-tick4 .num{
            position: absolute;
            left: -0.3rem;
            top:-5px;
            transform: rotate(-90deg); 
          }
          .line-tick5{
            transform: rotate(180deg);
          }
          .line-tick5 .num{
            position: absolute;
            left: -0.4rem;
            top:-5px;
            transform: rotate(180deg); 
          }
        }
        // .point_box:hover .point{
        //   transform: rotate(180deg);
        // }
        
      }
    }
  }
}
</style>
